// extracted by mini-css-extract-plugin
export default {"main":"main--qSBNo","error":"error--FL10y"};